import React, { useCallback, useEffect, useState } from "react";
import { GenericPopUp } from "../../../components/popup/genericPopUp";
import BorderHeading from "../../../components/heading/BorderHeading";
import { couponRowsData, popupType } from "../../../types/types";
import { TextField, Tooltip } from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridColumnHeaderParams,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { ManageCouponConfig } from "./ManageCouponConfig";
import { getAllCouponData } from "../../../services/manageCouponService";
import { Loader } from "../../../components/loader/Loader";
import EditModal from "./editInformation/EditModal";
import "./Coupons.css";

const Coupons = () => {
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [data, setData] = useState<couponRowsData[]>([]);
  const [rows, setRows] = useState<couponRowsData[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [editModalRow, setEditModalRow] = useState<couponRowsData>();
  const [loader, setLoader] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);

  const openPopup = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);

  const getAllCouponDataMethod = async () => {
    const response = await getAllCouponData();
    setRows(response.data.features);
    setData(response.data.features);
    setLoader(false);
  };

  const columns: GridColDef[] = ManageCouponConfig.columns.map(
    (columnsMetaData) => {
      return {
        disableColumnMenu: true,
        field: columnsMetaData.mappedValue,
        headerName: columnsMetaData.headerName,
        sortable: false,
        width: columnsMetaData.width,
        headerAlign: "left",
        align: "left",
        renderHeader: (params: GridColumnHeaderParams) => (
          <Tooltip title={columnsMetaData.headerName}>
            <b>{columnsMetaData.headerName.toUpperCase()}</b>
          </Tooltip>
        ),
      };
    }
  );

  const addActionAttributes = (
    field: string,
    headerName: "",
    action: (params: GridRenderCellParams) => JSX.Element
  ) => {
    columns.push({
      field,
      headerName,
      sortable: false,
      minWidth: 90,
      flex: 0.5,
      headerAlign: "left",
      align: "left",
      disableColumnMenu: true,
      renderCell: action,
    });
  };

  const openEditCouponDate = (id: string) => {
    setOpenModal(true);
    const row = rows.find((row: any) => row.id === id);
    setEditModalRow(row);
  };

  ManageCouponConfig.Actions.forEach((actionName: string) => {
    addActionAttributes("shortClose", "", (params: GridRenderCellParams) => {
      return (
        <button
          className="manage-order-table-button"
          onClick={() => openEditCouponDate(params.row.id)}
        >
          Short Close
        </button>
      );
    });
  });

  const filterData = (searchedValue: string) => {
    searchedValue = searchedValue.toLowerCase();
    const finalData = data.filter((eachRow: any) => {
      const allValues = Object.values(eachRow);
      return allValues.find((eachValue: any) => {
        return eachValue?.toString().toLowerCase().includes(searchedValue);
      });
    });
    setRows(finalData);
  };

  useEffect(() => {
    setLoader(true);
    getAllCouponDataMethod();
  }, [isUpdated]);

  useEffect(() => {
    if (isUpdated) {
      openPopup("Information updated", "Success");
    }
  }, [isUpdated]);

  return (
    <div className="manage-coupon-parent">
      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />
      <BorderHeading>Coupon Management</BorderHeading>
      <div className="manage-coupon-search-bar">
        <TextField
          className="manage-coupon-search-bar-textField"
          id="outlined-basic"
          label="Search"
          variant="outlined"
          size="small"
          fullWidth
          autoComplete="off"
          onChange={(e) => {
            filterData(e.target.value);
          }}
        />
      </div>
      {loader ? (
        <Loader />
      ) : (
        <div className="manage-order-table">
          <DataGrid
            disableRowSelectionOnClick={true}
            sx={{
              "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                outline: "none !important",
              },
            }}
            rows={rows}
            columns={columns}
            initialState={{
              sorting: {
                sortModel: [{ field: "id", sort: "asc" }],
              },
            }}
          />
        </div>
      )}

      {openModal && (
        <EditModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          isUpdated={isUpdated}
          setIsUpdated={setIsUpdated}
          couponData={editModalRow}
        />
      )}
    </div>
  );
};

export default Coupons;
